export const forceDropdownProp = (props) => {
  const hasDropdownUnitProp = Object.prototype.hasOwnProperty.call(
    props,
    "dropdownUnit",
  );
  return hasDropdownUnitProp ? props.dropdownUnit===true : false;
}
